export default __webpack_public_path__ + "static/media/photo--sm--48.ffa144b4.jpg";